// extracted by mini-css-extract-plugin
export var navbarSubLink = "P_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "P_vM d_f0 d_dB";
export var subPageLink = "P_gf d_gf";
export var burger = "P_xk";
export var sublinkSize = "P_xl";
export var linkSize = "P_xm";
export var Link = "P_vm C_vm C_tH C_t1";